import { useState, useEffect, useContext } from "react";
import { useCommon } from "../../../context/CommonContext";
import "./NcdForm.css";
import { NcdLoader } from "./NCDLoader";
import { Personalexamination } from "./Personalexamination";
import { Personalhistory } from "./Personalhistory";
import { Hypertension } from "./Hypertension";
import { Diabetes } from "./Diabetes";
import { OralScreeningCHO } from "./OralScreening-CHO";
import { BreastScreeningCHO } from "./BreastScreening-CHO";
import { CervicalScreeningCHO } from "./CervicalScreening-CHO";
import { ncdAPI } from "../../../services/ncd.api";
import { useNCD } from "../hooks/useNCD";
import { filterAccordionByPermissions } from "../../../utils/permissionHelper";
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, Dialog, DialogContent, DialogActions, Typography, Button } from "@mui/material";

import { CommonContext } from "../../../context/CommonContext";


export const NcdForm = ({
  hideSection,
  individualId,
  profileData,
  familyInfo,
  setShowNcdScreening,
}) => {
  const {
    loading,
    screeningIds,
    viewMode,
    openAccordionIndex,
    setLoading,
    setScreeningIds,
    setViewMode,
    toggleAccordion,
    setError,
    screeningData,
  } = useNCD();

  const {
    htnScreenId,
    diabScreenId,
    oralScreeningId,
    breastScreeningId,
    cervicalScreeningId,
  } = screeningIds;

  const [reScreening, setRescreening] = useState({});
  const [staffList, setStaffList] = useState([]);
  const { ncduser } = useCommon();
  const [selectedUser, setSelectedUser] = useState(null);
  const [userError, setUserError] = useState(false);
  const [isScreeningEnabled, setIsScreeningEnabled] = useState(false);
  const [loggedUserViaTrained, setLoggedUserViaTrained] = useState(null);
  const [showCervicalWarning, setShowCervicalWarning] = useState(false);

  const { fieldValues, setFieldValues } = useContext(CommonContext);

  useEffect(() => {
    if (
      ncduser?.rolename === "CHO" ||
      ncduser?.rolename === "ANM" ||
      ncduser?.rolename === "MPW"
    ) {
      setSelectedUser(ncduser?.username);
    } else {
      setSelectedUser(null);
    }

  }, [ncduser]);

  useEffect(() => {
    if (staffList.length > 0 && ncduser?.username) {
      const currentUser = staffList.find(
        (user) => user.username.toLowerCase() === ncduser.username.toLowerCase()
      );
      if (currentUser) {
        setLoggedUserViaTrained(currentUser.viaTrained);
      }
    }
  }, [staffList, ncduser]);

  useEffect(() => {
    const personalFields = ["height", "weight", "bmi"];

    const isFilledInContext = personalFields.some((field) => {
      const val = fieldValues?.[field];
      if (val === null || val === undefined) return false;
      return String(val).trim().length > 0;
    });

    const perexamValue = screeningData?.[`personalExamination_${individualId}`];
    const isFilledInRedux = !!(
      perexamValue &&
      perexamValue.height !== null &&
      perexamValue.height !== undefined &&
      String(perexamValue.height).trim().length > 0
    );

    setIsScreeningEnabled(isFilledInContext || isFilledInRedux);

  }, [fieldValues, screeningData, individualId]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const screeningresult = await ncdAPI.getScreenDetails(individualId);
        const screeningresultData = screeningresult?.data;

        if (screeningresultData) {
          setScreeningIds({
            oralScreeningId: screeningresultData[100].screeningId,
            breastScreeningId: screeningresultData[200].screeningId,
            cervicalScreeningId: screeningresultData[300].screeningId,
            htnScreenId: screeningresultData[500].screeningId,
            diabScreenId: screeningresultData[600].screeningId,
          });

          setRescreening({
            oralRescreening: screeningresultData[100]?.rescreeningEligibility,
            breastRescreening: screeningresultData[200]?.rescreeningEligibility,
            cervicalRescreening:
              screeningresultData[300]?.rescreeningEligibility,
            htnRescreening: screeningresultData[500]?.rescreeningEligibility,
            diabRescreening: screeningresultData[600]?.rescreeningEligibility,
          });
        }

        if (profileData?.subcenterId) {
          const shcUsers = await ncdAPI.getSubcenterUsers(profileData?.subcenterId);
          setStaffList(shcUsers?.data || []);
        }

        setLoading(false);
      } catch (error) {
        setError("Error fetching screen details");
        setLoading(false);
      }
    };

    if (individualId) {
      fetchData();
    }
  }, [individualId]);

  const handleModeChange = (mode) => {
    setLoading(false);
    setViewMode(mode);
  };

  // Get permissions from localStorage
  const ncdLoginData = localStorage.getItem("NCD_PERMISSIONS");
  const ncdToken = localStorage.getItem("NCD_token");

  let permissions = [];
  if (ncdLoginData) {
    try {
      permissions = JSON.parse(ncdLoginData) || [];
    } catch (error) {
      console.error("Error parsing NCD login data:", error);
    }
  }

  // Show access denied if no NCD token
  if (!ncdToken) {
    return (
      <>
        <div style={{ padding: "20px", textAlign: "center" }}>
          <h3>Access Denied</h3>
          <p>You are not logged into NCD module.</p>
        </div>
      </>
    );
  }


  const isAccordionDisabled = (type) => {
    if (viewMode !== "ADD") return false; // disable only in ADD mode if needed

    switch (type) {
      case "HTN":
        return !htnScreenId;
      case "DIAB":
        return !diabScreenId;
      case "ORAL":
        return !oralScreeningId;
      case "BREAST":
        return !breastScreeningId;
      case "CERVICAL":
        return !cervicalScreeningId;
      default:
        return false;
    }
  };



  // -----------------------------Accordian Data ---------------------------------------

  const accordionData = [
    {
      type: "PEREXAM",
      title: (
        <div className="title-container">
          <img
            src={"/images/PERSONAL-EXAMINATION.png"}
            alt="Hypertension Icon"
            className="icons_pro"
          />
          Personal Examination<span className="ng-star">*</span>
          <p className="mx-margin">
            Personal Examination is mandatory to add disease screening.
          </p>
        </div>
      ),
      content: (
        <>
          <Personalexamination
            individualId={individualId}
            viewMode={viewMode}
            selectedUser={selectedUser}
            setUserError={setUserError}
            handleModeChange={handleModeChange}
          />
        </>
      ),
    },
    {
      type: "PERHIS",
      title: (
        <div className="title-container">
          <img
            src={"/images/personal-history.png"}
            alt="Hypertension Icon"
            className="icons_pro"
          />
          Personal History
        </div>
      ),
      content: (
        <>
          <Personalhistory
            individualId={individualId}
            viewMode={viewMode}
            gender={profileData?.gender}
            selectedUser={selectedUser}
            setUserError={setUserError}
          />
        </>
      ),
    },
    {

      type: "HTN",
      title: (
        <div className="title-container">
          <img
            src={"/images/bp_readings.png"}
            alt="Hypertension Icon"
            className="icons_pro"
          />
          Hypertension{" "}
          {viewMode === "ADD" &&
            reScreening?.htnRescreening?.eligibleForRescreen && (
              <span className="rescreening-label">
                Re-Screening{" "}
                <small>
                  (
                  {reScreening?.htnRescreening?.eligibleForRescreen
                    ? "Rescreening due on" +
                    reScreening?.htnRescreening?.dueDate
                    : reScreening?.htnRescreening?.reason}
                  )
                </small>
              </span>
            )}
        </div>
      ),
      content: (
        <>
          <Hypertension
            individualId={individualId}
            htnScreenId={htnScreenId}
            viewMode={viewMode}
            reScreening={reScreening?.htnRescreening?.eligibleForRescreen}
            selectedUser={selectedUser}
            setUserError={setUserError}
          />
        </>
      ),
    },
    {
      type: "DIAB",
      title: (
        <div className="title-container">
          <img
            src={"/images/el_diabetes.png"}
            alt="Hypertension Icon"
            className="icons_pro"
          />
          Diabetes
        </div>
      ),
      content: (
        <>
          <Diabetes
            individualId={individualId}
            diabScreenId={diabScreenId}
            viewMode={viewMode}
            selectedUser={selectedUser}
            setUserError={setUserError}
          />
        </>
      ),
    },
    {
      type: "ORAL",
      title: (
        <div className="title-container">
          <img
            src={"/images/oral-screening.png"}
            alt="Hypertension Icon"
            className="icons_pro"
          />
          Oral Cancer
        </div>
      ),
      content: (
        <>
          <OralScreeningCHO
            individualId={individualId}
            oralScreeningId={oralScreeningId}
            viewMode={viewMode}
            onIdUpdate={(id) => setScreeningIds({ oralScreeningId: id })}
            selectedUser={selectedUser}
            setUserError={setUserError}
          />
        </>
      ),
    },

    // Breast Cancer - Only for Female
    ...(profileData?.gender?.toLowerCase() === "female"
      ? [
        {
          type: "BREAST",

          title: (
            <div className="title-container">
              <img
                src={"/images/breast-screening.png"}
                alt="Breast Cancer Icon"
                className="icons_pro"
              />
              Breast Cancer
            </div>
          ),
          content: (
            <BreastScreeningCHO
              individualId={individualId}
              breastScreeningId={breastScreeningId}
              viewMode={viewMode}
              onIdUpdate={(id) => setScreeningIds({ breastScreeningId: id })}
              selectedUser={selectedUser}
              setUserError={setUserError}
            />
          ),
        },
      ]
      : []),
    // Cervical Cancer - Only for Female
    ...(profileData?.gender?.toLowerCase() === "female"
      ? [
        {
          type: "CERVICAL",
          title: (
            <div className="title-container">
              <img
                src={"/images/cervical-screening.png"}
                alt="Cervical Cancer Icon"
                className="icons_pro"
              />
              Cervical Cancer
            </div>
          ),
          content: (
            <CervicalScreeningCHO
              individualId={individualId}
              cervicalScreeningId={cervicalScreeningId}
              viewMode={viewMode}
              onIdUpdate={(id) =>
                setScreeningIds({ cervicalScreeningId: id })
              }
              selectedUser={selectedUser}
              setUserError={setUserError}
            />
          ),
        },
      ]
      : []),
  ];

  const handleCervicalWarningConfirm = () => {
    setShowCervicalWarning(false);
    const cervicalIndex = accordionData.findIndex(item => item.type === "CERVICAL");
    if (cervicalIndex !== -1 && !openAccordionIndex.includes(cervicalIndex)) {
      toggleAccordion(cervicalIndex);
    }
  };

  // -------------------------------------------Accordian Data End -------------------------

  return (
    <>
      <section className="accordian_section" style={{ position: "relative" }}>
        {loading && <NcdLoader />}
        <div className="accordianScreenHeader">
          <h4 className="Header_accordian" id="screening-form-section">
            <span>
              <img
                src={"/images/programs_logo/ncd.svg"}
                alt=""
                style={{ width: "43px", margin: "0 10px 0 0" }}
              />
            </span>
            NCD Screening
            <div className="mode-toggle">
              <button
                className={`mode-btn left-btn ${viewMode === "VIEW" ? "active" : ""
                  }`}
                onClick={() => {
                  handleModeChange("VIEW");
                }}
              >
                View
              </button>
              <button
                className={`mode-btn right_btn ${viewMode === "ADD" ? "active" : ""
                  }`}
                onClick={() => handleModeChange("ADD")}
              >
                Add
              </button>
            </div>
          </h4>
          <div
            className="closeDive"
            onClick={() => {
              hideSection("NCDScreening");
              setViewMode("VIEW");
              setShowNcdScreening(false);
            }}
          >
            <img src={"/images/closing.svg"} alt="Close" />
          </div>
        </div>

        {viewMode === "ADD" && (

          <div className="shc-inline-field">
            <label className="shc-label">
              SHC Staff on whose behalf data is being captured
              <span className="text-star">:</span>
            </label>

            <FormControl sx={{ width: 300 }} size="small" error={userError} required>
              <InputLabel id="shc-staff-label">Select User ID</InputLabel>

              <Select
                labelId="shc-staff-label"
                label="Select User ID"
                value={selectedUser || ""}
                onChange={(e) => {
                  const user = staffList.find(
                    (s) => s.username === e.target.value
                  );
                  setSelectedUser(user?.username);   // ✅ only local update
                  setUserError(false); // ✅ remove error once selected
                }}
              >

                {staffList
                  .filter((staff) => staff.userType !== "ASHA")   // remove ASHA
                  .map((staff) => (
                    <MenuItem key={staff.username} value={staff.username}>
                      {staff.username} {staff.name ? `(${staff.name})` : ""}
                    </MenuItem>
                  ))}

              </Select>

              {userError && (
                <FormHelperText>
                  Please select SHC staff
                </FormHelperText>
              )}
            </FormControl>

            <span style={{ fontSize: "13px", color: "#333" }}>Subcenter: <label className="shc-label">{familyInfo?.addressInfo?.subcenter || "N/A"}</label></span>
            <p style={{ fontSize: "14px", display: 'block', flexBasis: '100%', margin: 0 }} ><span style={{ color: "red" }}>*</span> Personal Examination is mandatory to add disease screening.</p>
          </div>
        )}

        {filterAccordionByPermissions(accordionData, permissions).map(
          (accordion, index) => {
            const originalIndex = accordionData.findIndex(
              (item) => item === accordion
            );

            return (
              <>
                <div  
                  className="accordion"
                  key={originalIndex}
                  style={{
                    pointerEvents:
                      viewMode === "ADD" &&
                        !["PEREXAM", "PERHIS"].includes(accordion.type) &&
                        !isScreeningEnabled
                        ? "none"
                        : "auto",

                    opacity:
                      viewMode === "ADD" &&
                        !["PEREXAM", "PERHIS"].includes(accordion.type) &&
                        !isScreeningEnabled
                        ? 0.5
                        : 1,
                  }}
                >
                  <div
                    className="accordion-header"
                    onClick={() => {
                      if (viewMode === "ADD" && accordion.type === "CERVICAL" && (loggedUserViaTrained === false || loggedUserViaTrained === null) ) {
                        setShowCervicalWarning(true);
                        return;
                      }

                      if (
                        viewMode !== "ADD" || // always allow in VIEW mode
                        ["PEREXAM", "PERHIS"].includes(accordion.type) ||
                        isScreeningEnabled
                      ) {
                        toggleAccordion(originalIndex);
                      }
                    }}
                  >
                    <h6>{accordion.title}</h6>
                    <span
                      className={`accordion-icon ${openAccordionIndex.includes(originalIndex) ? "open" : ""
                        }`}
                    >
                      <img
                        src={"/images/Arrow.png"}
                        alt="arrow"
                        className={`arrow-icon ${openAccordionIndex.includes(originalIndex)
                          ? "rotate"
                          : "180"
                          }`}
                      />
                    </span>
                  </div>

                  {openAccordionIndex.includes(originalIndex) && (
                    <div className="accordion-content">{accordion.content}</div>
                  )}
                </div>
              </>
            );
          }
        )}
      </section>

      <Dialog
        open={showCervicalWarning}
        onClose={() => setShowCervicalWarning(false)}
        aria-labelledby="via-trained-dialog-title"
        PaperProps={{
          sx: {
            padding: '24px',
            borderRadius: '8px',
            maxWidth: '500px',
            width: '100%',
          }
        }}
      >
        <DialogContent sx={{ p: 0, mb: 3 }}>
          <Typography sx={{ fontSize: '16px', color: '#333', lineHeight: 1.5 }}>
            The SHC staff has not been trained for VIA and cervical examination, refer this individual to higher facility for Cervical Screening.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 0, justifyContent: 'flex-end' }}>
          <Button
            onClick={handleCervicalWarningConfirm}
            variant="contained"
            sx={{
              backgroundColor: '#3f51b5',
              color: '#fff',
              fontWeight: 'bold',
              minWidth: '80px',
              height: '40px',
              '&:hover': {
                backgroundColor: '#303f9f',
              }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
